import { Theme, useMediaQuery } from '@mui/material';

export const useScreenSize = () => {
    const isDesktopSize = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'), {
        defaultMatches: true
    });

    return { isDesktopSize };
};
